import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {allpayments} from "models/allpayments"; // Importing allpayments model
import {devConfig, gamesCasino, profile, providersCasino} from "config/config"; // Importing configuration settings

/**
 * Class representing the view for partner products table.
 * @extends JetView
 */
export default class tablePartnersProductsView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        var list1 = {
            view: "dbllist", // Double list view
            id:"dbllist", // ID for the double list
            list: {
              height: 0, // Height of the list
              scroll: true // Enable scrolling
            },
            labelLeft: _("Productos no habilitados"), // Left label for the double list
            labelRight: _("Productos habilitados"), // Right label for the double list
            data: [] // Initial data for the double list
        };
        return {
            view: "form", id: "f1", // Form view
            rows: [
                {
                  view: "forminput", // Input field for the form
                  name: "access", // Name of the input field
                  body: list1, // Body of the input field
                  labelWidth: 140, // Width of the label
                  labelAlign: "right" // Alignment of the label
                }
            ]
        };
      }
    
    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
      const _ = this.app.getService("locale")._; // Localization service
      var values=""; // Variable to hold included products
      const id_partner = this.getParam("partner", true); // Get partner ID from parameters
      var string1 = ""; // Query string for filtering
      var string2 = ""; // Variable to hold massive product data

      // Event listener for filtering partner products
      this.on(this.app, "partnerProducts:filter", filterData => {
          var object = Object.entries(filterData); // Convert filter data to entries
          string1 = ""; // Reset query string
          for (var i = 0; i < object.length; i++) {
              if ((typeof object[i][1] !== "object") && (object[i][1] !== "")) {
                  if (object[i][0] == "Datepicker") {
                      var date = object[i][1].split(" - "); // Split date range
                      console.log(date); // Log date range
                      string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                      string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                  } else {
                      string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                  }
              } else {
                  if ((typeof object[i][1] === "object")) {
                      var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                      for (var j = 0; j < object2.length; j++) {
                          if (object2[j][1] !== null) {
                              if (object2[j][0] === "start") {
                                  var d = new Date(object2[j][1]); // Create date object for start date
                                  var dateFrom = "dateFrom=" + ((d.getFullYear())) + ":" + ("00" + (d.getMonth() + 1)).slice(-2) + ":" + ("00" + d.getDate()).slice(-2) + " " + ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2);
                                  string1 = string1 + '&' + dateFrom; // Add formatted start date to query
                              } else {
                                  if (object2[j][0] === "end") {
                                      var d = new Date(object2[j][1]); // Create date object for end date
                                      var dateTo = "dateTo=" + ((d.getFullYear())) + ":" + ("00" + (d.getMonth() + 1)).slice(-2) + ":" + ("00" + d.getDate()).slice(-2) + " " + ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2);
                                      string1 = string1 + '&' + dateTo; // Add formatted end date to query
                                  }
                              }
                          }
                      }
                  }
              }
          }
          $$("dbllist").$$("left").clearAll(); // Clear left list
          $$("dbllist").setValue([]); // Reset selected values
          webix.ajax().get(devConfig.geturlApi() + "PartnersProducts/GetGroupPartnersProductsEnable", string1, { // AJAX request to get enabled products
              error: function (text, data, XmlHttpRequest) {
                  webix.message("Error! "); // Error message on failure
              },
              success: function (text, data, XmlHttpRequest) {
                  var data = JSON.parse(text); // Parse response data
                  if(!data.HasError){
                    $$("dbllist").$$("left").clearAll(); // Clear left list
                    $$("dbllist").setValue([]); // Reset selected values
                    $$("dbllist").parse(data.Data.ExcludedProductsList); // Parse excluded products
                    $$("dbllist").setValue(data.Data.IncludedProductsList); // Set included products
                    values=data.Data.IncludedProductsList; // Update values
                    string2 = ""; // Reset string2
                  }else{
                    webix.message("Error! "); // Error message if there's an error
                  }
              }
          });
      });

      // Event listener for massive product updates
      this.on(this.app, "partnerProducts:productMassive", filterData => {
          string2 = filterData; // Store massive product data
          webix.ajax().headers({
              "Content-type": "application/json" // Set content type for AJAX request
          }).post(devConfig.geturlApi() + "PartnersProducts/GetGroupPartnersProductsEnableMassive", filterData, {
              error: function (text, data, XmlHttpRequest) {
                  webix.message("Error! "); // Error message on failure
              },
              success: function (text, data, XmlHttpRequest) {
                  var data = JSON.parse(text); // Parse response data
                  if (!data.HasError) {
                      webix.message("Productos Masivos Agregados"); // Success message
                      $$("dbllist").$$("left").clearAll(); // Clear left list
                      $$("dbllist").setValue([]); // Reset selected values
                      $$("dbllist").parse(data.Data.ExcludedProductsList); // Parse excluded products
                      $$("dbllist").setValue(data.Data.IncludedProductsList); // Set included products
                      values = data.Data.IncludedProductsList; // Update values
                      string1 = ""; // Reset string1
                  } else {
                  }
              }
          })
      });

      // Event listener for changes in the double list
      $$('dbllist').attachEvent("onChange", function (id, e, node) {
          var array1= values.split(","); // Split included products into an array
          var array2= $$('dbllist').getValue().split(","); // Split currently selected products into an array
          var arrayAgregados = []; // Array for added products
          var arrayEliminados = []; // Array for removed products
          array2.forEach(function (obj) {
              var found = array1.find(function(element) {
                  return element == obj; // Check if product was previously included
              });
              if(found != undefined){
              }else{
                  arrayAgregados.push(obj); // Add to added products if not found
              }
          });
          array1.forEach(function (obj) {
              var found = array2.find(function(element) {
                  return element == obj; // Check if product is still selected
              });
              if(found == undefined){
                  arrayEliminados.push(obj); // Add to removed products if not found
              }else{
              }
          });

          webix.ui({
              view: "window", // Create a confirmation window
              head: {
                  view: "toolbar",
                  cols: [
                      {view: "label", label: _("Desea realizar movimiento?")} // Confirmation message
                  ]
              },
              position: "center", // Center the window
              modal: true, // Make the window modal
              body: {
                  view: "form", id: "form", elements: [
                      {view: "text", label: _("Observación"), name: "Note", required: true, labelWidth: 100}, // Observation input field
                      {cols: [
                        {
                            view: "button", value: _("Cancelar"), click: function () { // Cancel button
                                this.getTopParentView().hide(); // Hide the window
                                $$('form').setValues($$('form').getCleanValues()); // Reset form values
                                if(string1.length == 0 && string2.CSV != undefined  || string2.CSV != undefined){
                                    webix.ajax().headers({
                                        "Content-type": "application/json" // Set content type for AJAX request
                                    }).post(devConfig.geturlApi() + "PartnersProducts/GetGroupPartnersProductsEnableMassive", string2, {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message("Error! "); // Error message on failure
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var data = JSON.parse(text); // Parse response data
                                            if (!data.HasError) {
                                                $$("dbllist").$$("left").clearAll(); // Clear left list
                                                $$("dbllist").setValue([]); // Reset selected values
                                                $$("dbllist").parse(data.Data.ExcludedProductsList); // Parse excluded products
                                                $$("dbllist").setValue(data.Data.IncludedProductsList); // Set included products
                                                values = data.Data.IncludedProductsList; // Update values
                                            } else {
                                            }
                                        }
                                    })
                                }else if (string1.length !== 0) {
                                    webix.ajax().get(devConfig.geturlApi() + "PartnersProducts/GetGroupPartnersProductsEnable", string1, {
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message("Error! "); // Error message on failure
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var data = JSON.parse(text); // Parse response data
                                            if(!data.HasError){
                                                $$("dbllist").$$("left").clearAll(); // Clear left list
                                                $$("dbllist").setValue([]); // Reset selected values
                                                $$("dbllist").parse(data.Data.ExcludedProductsList); // Parse excluded products
                                                $$("dbllist").setValue(data.Data.IncludedProductsList); // Set included products
                                                values=data.Data.IncludedProductsList; // Update values
                                            }else{
                                                webix.message("Error! "); // Error message if there's an error
                                            }
                                        }
                                    });
                                }
                            }
                        },
                        {
                        view: "button", type: "form", value: _("Guardar"), click: function ($e) { // Save button
                            var valuesForm = $$("form").getValues(); // Get form values
                            if ($$("form").validate()) { // Validate form
                              var vthis = this; // Reference to the current instance
                                this.getTopParentView().hide(); // Hide the window
                                webix.ajax().headers({
                                  "Content-type": "application/json" // Set content type for AJAX request
                              }).post(devConfig.geturlApi() + "PartnersProducts/SavePartnerProductsEnable", '{"Partner":"'+ id_partner +'","IncludedProductsList":"'+arrayAgregados+'","ExcludedProductsList":"'+arrayEliminados+'","Note":"'+valuesForm.Note+'","CountrySelect":"'+$$("CountrySelect").getValue()+'"}', {
                                  error: function (text, data, XmlHttpRequest) {
                                      webix.message(_("Error! ")); // Error message on failure
                                      vthis.getTopParentView().hide(); // Hide the window
                                  },
                                  success: function (text, data, XmlHttpRequest) {
                                    var data = JSON.parse(text); // Parse response data
                                    if(!data.HasError){
                                      webix.message(_("Producto Partner Editado")); // Success message
                                        values = $$('dbllist').getValue(); // Update values with current selection
                                    }else{
                                      webix.message(_("Error! ")); // Error message if there's an error
                                    }
                                    vthis.getTopParentView().hide(); // Hide the window
                                  }
                              });
                            } else {
                                webix.message({
                                    title: _("¡Error!"),
                                    type: "alert-error",
                                    text: _("Completa los campos...") // Error message for incomplete fields
                                });
                            }
                        }
                      }]}
                  ], elementsConfig: {
                      on: {
                          onChange: function () {
                              this.validate(); // Validate form on change
                          }
                      }
                  }
              }
          }).show(); // Show the confirmation window
      });
    }
}

// FILE DOCUMENTED
